import { createRouter, createWebHistory } from "vue-router";
import { ReviseMeta } from "@/util/meta";
import { deviceType } from "@/util/base";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      component: () => import("./views/gw/index.vue"),
    },
    {
      path: "/m",
      component: () => import("./views/gw/index.vue"),
    },
    // 预约
    {
      path: "/pre",
      component: () => import("./views/gw/index.vue"),
    },
    // 预约
    {
      path: "/pre/m",
      component: () => import("./views/gw/index.vue"),
    },
    // 预约
    {
      path: "/pre/FB",
      component: () => import("./views/gw/index.vue"),
    },
    // 预约
    {
      path: "/pre/FB/m",
      component: () => import("./views/gw/index.vue"),
    },
    // 预约
    {
      path: "/pre/GG",
      component: () => import("./views/gw/index.vue"),
    },
    // 预约
    {
      path: "/pre//GG/m",
      component: () => import("./views/gw/index.vue"),
    },
    // 预约
    {
      path: "/pre/TT",
      component: () => import("./views/gw/index.vue"),
    },
    // 预约
    {
      path: "/pre/TT/m",
      component: () => import("./views/gw/index.vue"),
    },
    // 官网
    {
      path: "/home",
      component: () => import("./views/gw/index.vue"),
    },
    {
      path: "/home/m",
      component: () => import("./views/gw/index.vue"),
    },
    // 官网新闻
    {
      path: "/news",
      component: () => import("./views/gw/news.vue"),
    },
    {
      path: "/news/m",
      component: () => import("./views/gw/news.vue"),
    },
    // 官网内容
    {
      path: "/content",
      component: () => import("./views/gw/content.vue"),
    },
    {
      path: "/content/m",
      component: () => import("./views/gw/content.vue"),
    },
    {
      path: "/down/:version",
      component: () => import("./views/down/index.vue"),
      meta: {
        title: "Ragnarok Twilight - Pre-register to Get Mounts & Wings！",
        description:
          "The first RO Loot-Heroes Adventure RPG mobile game Ragnarok Twilight  is pre-registering now! Pre-register to get exclusive Mounts, rare costumes & wings.Draw iphone17pro, Gold Coins, and Merchandise! Defeat MVP can guarantee「100% Drop Rate」and level up easily by AFK gameplay. The debut 「Hero Transformation」 system lets players become legendary MVP/BOSS like Baphomet!",
        keywords:
          "RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight，RO Idle Adventure Plus,Ragnarok M:Eternal Love,Ragnarok:Origin,Ragnarok:BackToGlory, The Ragnarok,MMORPG,RPG,Loot,Bonus，GRAVITY，Baphomet，Classic Game，Ragnarok Online Official Website，RO online,MapleStorey，Genshin Impact，Wuthering Waves，Honkai：StarRail，Dragon Soul Traveler，mmo，rpg，Guild，Dungeon,Raid,Guild War，pvp，gvg，Zeny,Free Top Game，100%Drop Gear，Hero，Transformation，Poring，Baphomet",
      },
    },
    // 404
    {
      path: "/:pathMatch(.*)*",
      component: () => import("../../components/404.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description);

  const specialPages = [
    /^\/down(\/.*)?$/,
    /^\/shop(\/.*)?$/,
    /^\/resume(\/.*)?$/,
  ];
  const isSpecialPage = specialPages.some((pattern) => pattern.test(to.path));

  if (isSpecialPage) {
    next();
    return;
  }

  const isWap = deviceType() == "wap";
  const pcPath = to.path.replace(/\/m$/, "");
  const wapPath = pcPath.endsWith("/") ? `${pcPath}m` : `${pcPath}/m`;

  if (isWap && !to.path.endsWith("/m")) {
    next({ path: wapPath, query: to.query });
  } else if (!isWap && to.path.endsWith("/m")) {
    next({ path: pcPath, query: to.query });
  } else {
    next();
  }
});

export default router;
